import { MenuItems } from "../../../../common/AppSidebar/types";
import { NormalizedStorageObject } from "../../../../services/api/instances/storageApi/types/object_types";
import { TValueForService } from "../../../../services/api/instances/storageApi/types/service_types";
import type { StorageObjectState } from "../types";

export const LAST_SELECTED_KEY = "lastSelected";

export const APP_SERVICES_NAME: (keyof StorageObjectState)[] = [
  "krab",
  "assistants",
  "ai_agents_extra_app",
  "ai_agents_spa",
  "ai_agents_telegram_bots",
  "cases",
  "classify",
  "dialogs",
  "knowledge_base",
  "llm_compare",
  "meetings",
  "practicum",
  "research",
  "userfiles",
  "schemas",
  "stylizator",
  "skills",
  "usersettings",
];

export const EMPTY_MENU_ITEMS: MenuItems = [];

export const EMPTY_OBJECTS = [] as NormalizedStorageObject<
  TValueForService<any>
>[];
